// extracted by mini-css-extract-plugin
export default {"particleContainer":"Particles_particleContainer__GulKh","particle":"Particles_particle__Un7rC boxShadow","downHide":"Particles_downHide__bHAQ+"};